import React from "react";
import { useSitesQueryShortQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const SiteSelect = (props) => {
    const query = useSitesQueryShortQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props} labelField="name" />:<GraphQlSelect queryResult={query} {...props} labelField="name" />;
}
